module.exports = __webpack_public_path__ + "img/icon_map_13_on_011.275e66d3.png";